import styled from 'styled-components'
import Drawer from 'components/common/Drawer'
import Icon from 'components/common/Icon/Icon'

export const FilterFacet = styled(Drawer)`
  padding: 21px 20px 21px 0;
  border-width: 1px 0 0;

  [data-global-search-summary] + & {
    border-width: 0;
  }

  & ${Icon} {
    top: 20px;
    right: 0;
  }

  &:last-of-type {
    border-width: 1px 0;
  }
`
